<script> 
	export let params = {};
	
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import { 
		TipoEvento, 
		dadosUsuarioLS, 
		API, 
		cabecalhoPadraoRequisicao,
		StatusHttp, 
		TextoFeedback } from '../../utils';
	const dispatch = createEventDispatcher();
	
	let listagemObjetosAvaliados = [];
	let dadosUsuario;

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Recuperando avaliações ...',
		});
		
		dadosUsuario = dadosUsuarioLS();
		
		let { dados } = await carregarAvaliacoesPorCPF();

		listagemObjetosAvaliados = dados;

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	const carregarAvaliacoesPorCPF = async () => {
		const resposta = await fetch(API(`usuarios/listagem/avaliacoes/${params.cpf}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao(),
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			return json;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma avaliação vinculada ao CPF deste usuário.'
			});

			replace("#/painel");
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: json?.mensagem
			});
			
			replace("#/painel");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<style>
.container_tabela {
	overflow-x: auto;
}
</style>

<TBoxInterno 
	titulo="Listagem de Avaliações" 
	subtitulo="Relação de avaliações do CPF: {params.cpf}"
	largura="12" 
	correcaoY="-32px"
	icone="avaliacao"
	deslocamento="0">

	<div class="container_tabela">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>Ação</th>
					<th>Tipo</th>
					<th>Pontuação</th>
					<th>Status</th>
					<th>Data da avaliação</th>
					<th>Data da última atualização</th>
					<th>Excluída</th>
				</tr>
			</thead>
			<tbody>
				{#each listagemObjetosAvaliados as valor}
				<tr>
					<td><a href="#/avaliacao/visualizar/{valor.id}">Abrir</a></td>
					<td>{ valor.tipoObjetoAvaliado }</td>
					<td>{ valor.pontuacao }</td>
					<td>{ valor.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
					<td>{ valor.data_criacao }</td>
					<td>{ valor.data_ultima_atualizacao }</td>
					<td>{ valor.excluida == true ? 'SIM' : 'NÃO' }</td>
				</tr>
				{/each}
			</tbody>
		</table>
	</div>
</TBoxInterno>